import { RootState } from '../../../store';

export const selectPriceList = (state: RootState) => state.subscription.prices;
export const selectSelectedPrice = (state: RootState) => state.subscription.common.selectedPrice;
export const selectCurrentSubscription = (state: RootState) => state.subscription.currentSubscription;
